import { combineEpics } from 'redux-observable';
import AuthEpics from './AuthEpics';
import BookingEpics from './BookingEpics';
import SessionEpics from './SessionEpics';
import DestinationEpics from './DestinationEpics';
import SchoolBookingEpics from './SchoolBookingEpics';
import SchoolSessionEpics from './SchoolSessionEpics';
import SchoolEpics from './SchoolEpics';
import SchoolListingEpics from './SchoolListingEpics';
import SchoolSettingsEpics from './SchoolSettingsEpics';
import SchoolSpotEpics from './SchoolSpotEpics';
import SchoolUserEpics from './SchoolUserEpics';
import PublicDataEpics from './PublicDataEpics';
import SignInEpics from './SignInEpics';
import SchoolSubscriptionsEpics from './SchoolSubscriptionsEpics';
import InstructorEpics from './InstructorEpics';
import SchoolOnboardEpics from './SchoolOnboardEpics';
import SchoolJobsEpics from './SchoolJobsEpics';
import UserEpics from './UserEpics';

// see https://github.com/redux-observable/redux-observable/issues/219

export default combineEpics(
  AuthEpics as any,
  BookingEpics,
  SessionEpics,
  DestinationEpics,
  PublicDataEpics,
  SchoolBookingEpics,
  SchoolSessionEpics,
  SchoolEpics,
  SchoolListingEpics,
  SchoolSettingsEpics,
  SchoolSpotEpics,
  SchoolUserEpics,
  SignInEpics,
  SchoolSubscriptionsEpics,
  InstructorEpics,
  SchoolOnboardEpics,
  SchoolJobsEpics,
  UserEpics
);
